import { defineComponent as _defineComponent } from 'vue'
import SubNavigation from '@/ui/chrome/menu/SubNavigation.vue';
import { computed, ref, watch } from 'vue';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainMenuItem',
  props: {
    mainNavigationItem: null,
    measurements: null,
    popoutOpen: { type: Boolean },
    first: { type: Boolean }
  },
  emits: ["toggleMegaMenuPopout", "closeSubmenu"],
  setup(__props: any, { emit }: { emit: ({(e: 'toggleMegaMenuPopout', value: boolean) : void, (e: 'closeSubmenu') : void}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    mainNavigationItem?: INavigationViewObject,
    measurements?: MegamenuMeasurements,
    popoutOpen?: boolean,
    first?: boolean
}




const showAuthTopBar = computed<boolean>(() => store.getters['app/showAuthTopBar']);
const showEmptyTopBar = computed<boolean>(() => store.getters['app/showEmptyTopBar']);
const active = ref<boolean>(false);
const hasChildren = computed<boolean>(() => {
    return props.mainNavigationItem.submenu && props.mainNavigationItem.submenu.length > 0;
});
const openSubNavigation = ref<boolean>(false);
const openState = computed<boolean>(() => {
    return openSubNavigation.value && props.popoutOpen;
});

function onOpenStateChange() {
    setTimeout(() => {
        if (openState.value) {
            emit('toggleMegaMenuPopout', true);
        }
    }, 10);
}
watch(openState, onOpenStateChange);

function onMouseEnter() {
    if (!hasChildren.value) {
        emit('toggleMegaMenuPopout', false);
        return;
    }
    openSubNavigation.value = true;
    emit('toggleMegaMenuPopout', true);
}

function onMouseLeave() {
    openSubNavigation.value = false;
    active.value = false;
}

function onItemEnter() {
    active.value = true;
}

function onCloseSubmenu() {
    emit('closeSubmenu');
}

function closeSubmenu() {
    onMouseLeave();
    onCloseSubmenu();
}

return { __sfc: true,props, emit, showAuthTopBar, showEmptyTopBar, active, hasChildren, openSubNavigation, openState, onOpenStateChange, onMouseEnter, onMouseLeave, onItemEnter, onCloseSubmenu, closeSubmenu, SubNavigation }
}

})